var _filter, _filter2, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _line, _line2, _line3, _line4, _path, _circle9, _circle0, _circle1, _circle10, _text, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNuraLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "circleGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#667eea",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#764ba2",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "borderGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#64ffda",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#667eea",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a2e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#16213e",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f0f23",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 8,
    stdDeviation: 12,
    floodColor: "#667eea",
    floodOpacity: 0.3
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 75,
    fill: "url(#borderGradient)",
    opacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 150,
    r: 70,
    fill: "url(#circleGradient)",
    filter: "url(#shadow)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 120,
    r: 3,
    fill: "#64ffda",
    opacity: 0.6
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 240,
    cy: 110,
    r: 3,
    fill: "#64ffda",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 180,
    r: 3,
    fill: "#64ffda",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 185,
    r: 3,
    fill: "#64ffda",
    opacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 150,
    r: 3,
    fill: "#64ffda",
    opacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 160,
    r: 3,
    fill: "#64ffda",
    opacity: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: 120,
    x2: 200,
    y2: 140,
    stroke: "#64ffda",
    strokeWidth: 1,
    opacity: 0.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 240,
    y1: 110,
    x2: 210,
    y2: 135,
    stroke: "#64ffda",
    strokeWidth: 1,
    opacity: 0.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: 180,
    x2: 200,
    y2: 160,
    stroke: "#64ffda",
    strokeWidth: 1,
    opacity: 0.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 185,
    x2: 210,
    y2: 165,
    stroke: "#64ffda",
    strokeWidth: 1,
    opacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 175 135 Q 175 125 185 125 L 215 125 Q 225 125 225 135 L 225 155 Q 225 165 215 165 L 190 165 Q 185 165 182 168 L 178 172 Q 175 175 175 170 L 175 155 Z",
    fill: "white",
    filter: "url(#shadow)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 190,
    cy: 145,
    r: 2.5,
    fill: "#667eea"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 145,
    r: 2.5,
    fill: "#667eea"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "1.5s",
    begin: "0.2s",
    repeatCount: "indefinite"
  }))), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 210,
    cy: 145,
    r: 2.5,
    fill: "#667eea"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "0.4;1;0.4",
    dur: "1.5s",
    begin: "0.4s",
    repeatCount: "indefinite"
  }))), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 220,
    cy: 130,
    r: 8,
    fill: "#64ffda",
    filter: "url(#glow)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 220,
    y: 135,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 10,
    fill: "#0f0f23"
  }, "\u26A1")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 280,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 42,
    fontWeight: "bold",
    fill: "url(#textGradient)",
    filter: "url(#glow)"
  }, "NuraAI")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 310,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fontWeight: 300,
    fill: "#2d3748",
    opacity: 0.8,
    letterSpacing: "2px"
  }, "INTELLIGENT CONVERSATIONS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuraLogoDark);
export default __webpack_public_path__ + "static/media/nura-logo-dark.ed94c78a1f9df0016cc957b820668e90.svg";
export { ForwardRef as ReactComponent };